<div [formGroup]="userForm" class="form flex flex-col">
  <nx-edit-text-input
    formControlName="email"
    [placeholder]="'core.userDialogComponent.form.email.placeholder' | translate"
    [label]="'core.userDialogComponent.form.email.label' | translate">
  </nx-edit-text-input>
  <nx-edit-text-input
    formControlName="initials"
    [placeholder]="'core.userDialogComponent.form.initials.placeholder' | translate"
    [label]="'core.userDialogComponent.form.initials.label' | translate">
  </nx-edit-text-input>
  <nx-edit-text-input
    formControlName="firstName"
    [placeholder]="'core.userDialogComponent.form.firstName.placeholder' | translate"
    [label]="'core.userDialogComponent.form.firstName.label' | translate">
  </nx-edit-text-input>
  <nx-edit-text-input
    formControlName="lastName"
    [placeholder]="'core.userDialogComponent.form.lastName.placeholder' | translate"
    [label]="'core.userDialogComponent.form.lastName.label' | translate">
  </nx-edit-text-input>
  <nx-edit-text-input
    formControlName="externalId"
    [placeholder]="'core.userDialogComponent.form.externalId.placeholder' | translate"
    [label]="'core.userDialogComponent.form.externalId.label' | translate">
  </nx-edit-text-input>
  <nx-edit-multiselect-input
    formControlName="groupIds"
    [label]="'core.userDialogComponent.form.groups.label' | translate"
    [options]="groups">
  </nx-edit-multiselect-input>
  <nx-edit-multiselect-input
    formControlName="locationIds"
    [label]="'core.userDialogComponent.form.locations.label' | translate"
    [options]="locations">
  </nx-edit-multiselect-input>
  <nx-edit-text-input
    *ngIf="!user"
    [maskContent]="true"
    formControlName="password"
    [helpText]="'core.userDialogComponent.form.password.helpText' | translate" 
    [label]="'core.userDialogComponent.form.password.label' | translate">
  </nx-edit-text-input>
<div>